"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authWinnerContract = void 0;
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("../prize/models");
const models_2 = require("./models");
const ZPrizeWinCore = models_2.ZPrizeWinSelect.pick({
    id: true,
    ticketEntryId: true,
    status: true,
    prizeTierId: true,
}).extend({
    createdAt: zod_1.z.coerce.date(),
    gameType: zod_1.z.string(),
    prizeStructureCode: zod_1.z.string(),
    prizeTierCode: zod_1.z.string(),
    prizeTierType: zod_1.z.string(),
    drawId: zod_1.z.number(),
    drawName: zod_1.z.string(),
});
const ZGetUnclaimedPrizeWinsResponse = ZPrizeWinCore.extend({
    expiresAt: zod_1.z.coerce.date().nullable(),
    drawPrizeId: zod_1.z.number().nullable(),
    drawPrizeSlug: zod_1.z.string().nullable(),
    drawPrizeTitle: zod_1.z.string().nullable(),
    drawPrizeSubheading: zod_1.z.string().nullable(),
    drawPrizeImageLocation: zod_1.z.string().nullable(),
}).array();
const ZGetClaimedPrizeWinsResponse = ZPrizeWinCore.extend({
    chosenAt: zod_1.z.coerce.date().nullable(),
    chosenPrizeId: zod_1.z.number().nullable(),
    chosenPrizeName: zod_1.z.string().nullable(),
    chosenPrizeDescription: zod_1.z.string().nullable(),
    chosenPrizeImageLocation: zod_1.z.string().nullable(),
    chosenPrizeProducts: models_1.ZProductSelect.pick({
        id: true,
        name: true,
        autoFulfilmentCode: true,
    })
        .extend({ prizeOrderProductId: zod_1.z.string() })
        .array()
        .nullable(),
    isChosenByPlayer: zod_1.z.boolean(),
    feedbackRating: zod_1.z.coerce.number().nullable(),
    feedbackComment: zod_1.z.string().nullable(),
}).array();
const ZGetTreatPrizeWinsResponse = ZPrizeWinCore.extend({
    chosenPrizeId: zod_1.z.number().nullable(),
}).array();
const ZGetAvailablePrizesForRedemptionResponse = zod_1.z.object({
    displayGroupPrizes: zod_1.z.record(zod_1.z.string(), models_1.ZPrizeCore.array()),
    allAvailablePrizes: models_1.ZPrizeCore.array(),
    winType: zod_1.z.nativeEnum(dbEnums_1.WinType),
});
const ZGetPrizeBySlugForRedemptionResponse = models_1.ZPrizeSelect.pick({
    id: true,
    title: true,
    subheading: true,
    slug: true,
    imageLocations: true,
    isFromPlayersSuggestion: true,
    type: true,
    overviewBody: true,
    whatsIncludedHeading: true,
    whatsIncludedBody: true,
    requiresDeliveryAddress: true,
    requiresEmailAddress: true,
    requiresPhoneNumber: true,
    additionalQuestionsForPlayer: true,
}).extend({
    products: models_1.ZProductSelect.pick({
        id: true,
        name: true,
        description: true,
        imageLocation: true,
        autoFulfilmentCode: true,
    }).array(),
});
const ZSubmitPrizeChoiceRequest = zod_1.z
    .object({
    prizeWinId: zod_1.z.string(),
    prizeId: zod_1.z.coerce.number(),
    productId: zod_1.z.coerce.number().optional(),
})
    .merge(models_2.ZPrizeOrderInsert.pick({
    deliveryStreet: true,
    deliveryCity: true,
    deliveryPostcode: true,
    emailAddress: true,
    phoneNumber: true,
    additionalInfoFromPlayer: true,
}));
const c = (0, core_1.initContract)();
exports.authWinnerContract = c.router({
    getUnclaimedPrizeWins: {
        method: 'GET',
        path: '/get-unclaimed-prize-wins',
        responses: {
            200: ZGetUnclaimedPrizeWinsResponse,
        },
        summary: 'Get unclaimed prize/treat wins of a player',
    },
    getClaimedPrizeWins: {
        method: 'GET',
        path: '/get-claimed-prize-wins',
        responses: {
            200: ZGetClaimedPrizeWinsResponse,
        },
        summary: 'Get claimed prize/treat wins of a player',
    },
    getTreatPrizeWins: {
        method: 'GET',
        path: '/get-treat-prize-wins',
        query: zod_1.z.object({
            drawId: zod_1.z.coerce.number().optional(),
        }),
        responses: {
            200: ZGetTreatPrizeWinsResponse,
        },
        summary: 'Get prize/treat wins of a player (with filter options)',
    },
    getAvailablePrizesForRedemption: {
        method: 'GET',
        path: '/get-available-prizes-for-redemption',
        query: zod_1.z.object({
            prizeWinId: zod_1.z.string(),
        }),
        responses: {
            200: ZGetAvailablePrizesForRedemptionResponse,
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Get prize/treat win details and available prizes for prize redemption',
    },
    getPrizeBySlugForRedemption: {
        method: 'GET',
        path: '/get-prize-by-slug-for-redemption',
        query: zod_1.z.object({
            slug: zod_1.z.string(),
        }),
        responses: {
            200: ZGetPrizeBySlugForRedemptionResponse,
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Get a prize for prize redemption form',
    },
    submitPrizeChoice: {
        method: 'POST',
        path: '/submit-prize-choice',
        body: ZSubmitPrizeChoiceRequest,
        responses: {
            200: zod_1.z.object({
                prizeOrderId: zod_1.z.string(),
                prizeOrderProductIds: zod_1.z.string().array(),
            }),
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Submit choice of prize for a prize win',
    },
}, {
    pathPrefix: '/auth',
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=winner.auth.contract.js.map